var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Detalles del Expediente",
        centered: "",
        "hide-footer": ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "vs-tabs",
        [
          _c(
            "vs-tab",
            { attrs: { label: "Remitente" } },
            [
              _c(
                "vs-list",
                [
                  _c("vs-list-item", {
                    staticStyle: {
                      "border-bottom": "1px solid #cdcdcd",
                      "padding-bottom": "12px"
                    },
                    attrs: {
                      icon: "description",
                      title: _vm.file.emisorCentroCostoNombre,
                      subtitle: "Tipo de documento"
                    }
                  }),
                  _vm.file.emisorSucursalDireccion
                    ? _c("vs-list-item", {
                        staticStyle: {
                          "border-bottom": "1px solid #cdcdcd",
                          "padding-bottom": "12px"
                        },
                        attrs: {
                          icon: "description",
                          title: _vm.file.emisorSucursalDireccion,
                          subtitle: "Documento"
                        }
                      })
                    : _vm._e(),
                  _c("vs-list-item", {
                    staticStyle: {
                      "border-bottom": "1px solid #cdcdcd",
                      "padding-bottom": "12px"
                    },
                    attrs: {
                      icon: "account_balance",
                      title: _vm.file.compradorArea,
                      subtitle: "Tipo institución"
                    }
                  }),
                  _vm.file.emisorContactoArea
                    ? _c("vs-list-item", {
                        staticStyle: {
                          "border-bottom": "1px solid #cdcdcd",
                          "padding-bottom": "12px"
                        },
                        attrs: {
                          icon: "account_balance",
                          title: _vm.file.emisorContactoArea,
                          subtitle: "Institución "
                        }
                      })
                    : _vm._e(),
                  _vm.file.emisorContactoNombre
                    ? _c("vs-list-item", {
                        staticStyle: {
                          "border-bottom": "1px solid #cdcdcd",
                          "padding-bottom": "12px"
                        },
                        attrs: {
                          icon: "account_circle",
                          title: _vm.file.emisorContactoNombre,
                          subtitle: "Persona"
                        }
                      })
                    : _vm._e(),
                  _c("vs-list-item", {
                    staticStyle: {
                      "border-bottom": "1px solid #cdcdcd",
                      "padding-bottom": "12px"
                    },
                    attrs: {
                      icon: "assignment_ind",
                      title: _vm.file.emisorContactoCargo,
                      subtitle: "Cargo persona"
                    }
                  }),
                  _c("vs-list-item", {
                    staticStyle: {
                      "border-bottom": "1px solid #cdcdcd",
                      "padding-bottom": "12px"
                    },
                    attrs: {
                      icon: "assignment_ind",
                      title: _vm.file.emisorContactoEmail,
                      subtitle: "Correo persona"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Adjuntos" } },
            [
              _c(
                "vs-list",
                _vm._l(_vm.detailsFile.adjuntos, function(attachment) {
                  return _c(
                    "div",
                    { key: attachment.adjuntoId },
                    [
                      _c(
                        "vs-list-item",
                        {
                          staticStyle: {
                            "border-bottom": "1px solid #cdcdcd",
                            "padding-bottom": "12px"
                          },
                          attrs: {
                            icon: "attach_file",
                            title: attachment.adjuntoNombre,
                            subtitle: attachment.tipo
                          }
                        },
                        [
                          attachment &&
                          attachment.adjuntoNombre &&
                          attachment.adjuntoUrl
                            ? _c("DownloadFile", {
                                staticClass: "pill-info-attach",
                                attrs: {
                                  path: attachment.adjuntoUrl,
                                  name: attachment.adjuntoNombre
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Destinatarios" } },
            [
              _c(
                "vs-list",
                { staticClass: "box-participants" },
                _vm._l(_vm.detailsFile.destinatarios || [], function(
                  subject,
                  index
                ) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      subject.tipoDestino === "1"
                        ? _c(
                            "vs-list-item",
                            {
                              staticStyle: {
                                "border-bottom": "1px solid #cdcdcd",
                                "padding-bottom": "12px"
                              },
                              attrs: {
                                icon: "contact_mail",
                                title: subject.destinoListaNombre,
                                subtitle: subject.destinoNombre
                              }
                            },
                            [
                              subject.tipoDestino === "1"
                                ? _c(
                                    "vs-chip",
                                    { attrs: { color: "primary" } },
                                    [_vm._v(" Destinatario ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      subject.tipoDestino === "2"
                        ? _c(
                            "vs-list-item",
                            {
                              staticStyle: {
                                "border-bottom": "1px solid #cdcdcd",
                                "padding-bottom": "12px"
                              },
                              attrs: {
                                icon: "supervised_user_circle",
                                title: subject.destinoListaNombre,
                                subtitle: subject.destinoNombre
                              }
                            },
                            [
                              subject.tipoDestino === "2"
                                ? _c(
                                    "vs-chip",
                                    { attrs: { color: "#43C3B9" } },
                                    [_vm._v(" En copia ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Referencias" } },
            [
              _c(
                "vs-table",
                {
                  attrs: { stripe: "", data: _vm.detailsFile.referencias || [] }
                },
                [
                  _c("template", { slot: "header" }),
                  _c(
                    "template",
                    { slot: "thead" },
                    [
                      _c("vs-th", [_vm._v(" Tipo Documento ")]),
                      _c("vs-th", [_vm._v(" Número ")])
                    ],
                    1
                  ),
                  [
                    _c(
                      "tbody",
                      [
                        _vm.file.transportePuertoCodigo
                          ? _c(
                              "vs-tr",
                              [
                                _c("vs-td", [_vm._v(" Contrato SAFI ")]),
                                _c("vs-td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.file.transportePuertoCodigo) +
                                      " "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._l(_vm.detailsFile.referencias || [], function(
                          reference
                        ) {
                          return _c(
                            "vs-tr",
                            { key: reference.dntReferenciaId },
                            [
                              _c("vs-td", [
                                _vm._v(
                                  " " + _vm._s(reference.tipoDocumento) + " "
                                )
                              ]),
                              _c("vs-td", [
                                _vm._v(" " + _vm._s(reference.folio) + " ")
                              ])
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }